import { useState } from "react";
import { getApi } from "../../../services/api/globalApi";
import ExportExcel from "../../../components/common/export-exel/ExportExel";
import Table from "../../../components/common/table/Table";
import { ordersUniqueMobileReportsColumns } from "../../../constant/tablesColumns/tablesColums";
import { convertDate } from "../../../utils/convertDate";
import OrdersUniqueMobileSalesReportFilter from "./OrdersUniqueMobileSalesReportFilter";

export default function OrdersUniqueMobileSalesReport() {
  const [reportsData, setReportsData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [activeSearchButton, setActiveSearchButton] = useState(true);

  const getOrdersReports = async (params) => {
    const path = "/admin/reports/allUniqueMobileOldAndNewWebsiteUsersOrders";
    try {
      setActiveSearchButton(false);
      const response = await getApi({ path, params: { ...params } });
      setReportsData(response?.data?.result);
      setActiveSearchButton(true);
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };
  const [filter, setFilter] = useState();

  const filterDataHandler = (newParams) => {
    setFilter({ ...filter, ...newParams });
    const allFilter = {
      ...filter,
      ...newParams,
    };
    getOrdersReports(allFilter);
  };
  const exportReportsDataType1 = [];
  const exportReportsDataType2 = [];

  reportsData?.forEach((item) => {
    const info = {
      نام: item.name,
      "شماره تماس": item.mobile,
      "تعداد سفارش": item?.orderCount,
      "مجموع سفارش  ": item?.sumTotalPrice,
      "آدرس کامل": `${item.province} - ${item.city} - ${item.address}`,
      کدپستی: item.postcode,
      نماینده: item.ref?.name,
      "شماره تماس نماینده": item.ref?.mobile,
      "لینک کد":
        item.userRole === "affiliate" ? "" : item.user?.linkCodes?.join(","),
      "آخرین تاریخ خرید": convertDate(item.paymentDate),
      "نام کاربر ثبت کننده آخرین سفارش": item.user?.name,
      "نام محصول": "",
      "تعداد خرید": "",
    };
    exportReportsDataType1.push(info);
    item.products.forEach((i) => {
      exportReportsDataType1.push({
        نام: "",
        "شماره تماس": "",
        "تعداد سفارش": "",
        "مجموع سفارش  ": "",
        "آدرس کامل": "",
        کدپستی: "",
        نماینده: item.ref?.name,
        "شماره تماس نماینده": item.ref?.mobile,
        "لینک کد": item.userRole === "affiliate" ? "" : item.linkCode,
        "آخرین تاریخ خرید": "",
        "نام کاربر ثبت کننده آخرین سفارش": "",
        "نام محصول": i.productName,
        "تعداد خرید": i.count,
      });
    });
    //type 2
    const info2 = {
      نام: item.name,
      "شماره تماس": item.mobile,
      "تعداد سفارش": item?.orderCount,
      "مجموع سفارش  ": item?.sumTotalPrice,
      "نقش کاربر ثبت کننده سفارش": "",
      "نام کاربر ثبت کننده سفارش": "",
      "شماره سفارش ": "",
      "مجموع خرید": "",
      "تاریخ سفارش": "",
      "لینک کد": "",
      نماینده: "",
      "شماره تماس نماینده": "",
      آدرس: "",
      کدپستی: "",
      "قیمت محصول": "",
      "نام کالا": "",
      "تعداد کالا": "",
    };
    exportReportsDataType2.push(info2);
    item.allOrders?.forEach((order) => {
      exportReportsDataType2.push({
        "شماره سفارش ": order.trackingCode,
        "مجموع خرید": order.totalProductsPrice,
        "تاریخ سفارش": convertDate(order.paymentDate),
        "نقش کاربر ثبت کننده سفارش": order.user?.role,
        "نام کاربر ثبت کننده سفارش": order.user?.name,
        نماینده: order.ref?.name,
        "شماره تماس نماینده": order.ref?.mobile,
        "لینک کد": order.userRole === "affiliate" ? "" : order.linkCode,
        آدرس: `${order.province} - ${order.city} - ${order.address}`,
        کدپستی: order.postcode,
      });

      order.products.forEach((product) => {
        exportReportsDataType2.push({
          نام: "",
          "شماره تماس": "",
          "تعداد سفارش": "",
          "مجموع سفارش  ": "",
          "شماره سفارش ": "",
          "مجموع خرید": "",
          "تاریخ سفارش": "",
          "نام کالا": product.productName,
          "تعداد کالا": product.count,
          "قیمت ": product.totalPrice,
          نماینده: "",
          "شماره تماس نماینده": "",
          "لینک کد": "",
          آدرس: "",
          کدپستی: "",
        });
      });
    });
  });
  return (
    <div className="bg-white dark:bg-gray-900 rounded-3xl p-6">
      <div className="flex flex-wrap items-center justify-between gap-3">
        <h3 className="text-gray-800 dark:text-white">گزارش سفارشات نوع 2</h3>
        <div className="flex flex-wrap items-center gap-2">
          <ExportExcel
            jsonData={exportReportsDataType1}
            title={"دانلود نوع 1"}
          />
          <ExportExcel
            jsonData={exportReportsDataType2}
            title={"دانلود نوع 2"}
          />
        </div>
      </div>
      <OrdersUniqueMobileSalesReportFilter
        filterDataHandler={filterDataHandler}
        activeSearchButton={activeSearchButton}
      />
      {loading && (
        <div className="text-center text-blue-600 font-medium my-4">
          در حال جستجو...
        </div>
      )}

      <Table columns={ordersUniqueMobileReportsColumns} rows={reportsData} />
    </div>
  );
}
